import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  @Input() items: any[];
  @Input() type: string;
  @Output() selectedItem: EventEmitter<any> = new EventEmitter();
  @Output() selectedItemIndex: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void { }

  public onSelect(item, index): void {
    this.selectedItem.emit(item);
    this.selectedItemIndex.emit(index);
  }

}
